export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Revogar no mesmo tick cancela o download em alguns navegadores.
  window.setTimeout(function () {
    window.URL.revokeObjectURL(url);
  }, 0);
}

export function filenameFromDisposition(disposition, fallback) {
  if (!disposition) return fallback;

  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
  if (utf8 && utf8[1]) return decodeURIComponent(utf8[1].trim());

  const plain = /filename="?([^";]+)"?/i.exec(disposition);
  if (plain && plain[1]) return plain[1].trim();

  return fallback;
}

/**
 * Com `responseType: 'blob'` o axios entrega TAMBÉM o corpo de erro como Blob, então
 * `handleApiError` perderia a mensagem do backend e cairia no fallback genérico. Converte
 * o corpo de volta para objeto para o erro seguir tratável como qualquer outro.
 */
export async function readBlobError(error) {
  const response = error && error.response;
  const data = response && response.data;

  if (!data || typeof Blob === 'undefined' || !(data instanceof Blob)) {
    return error;
  }

  try {
    const text = await data.text();
    response.data = JSON.parse(text);
  } catch (parseError) {
    response.data = null;
  }

  return error;
}
